import styled from "styled-components"
import {
  pixelsToNumber,
  numberToPixels,
  fullWidth as _fullWidth,
} from "src/styles/helpers"

type Props = {
  mt?: number
  mb?: number
  ml?: number
  mr?: number
  pl?: number
  pr?: number
  pt?: number
  pb?: number
  fullWidth?: boolean
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createSpacing = (theme: any, multiplier: number | undefined) =>
  multiplier == null
    ? 0
    : numberToPixels(pixelsToNumber(theme.spacing.baseSpacing) * multiplier)

export const Spacer = styled.span<Props>`
  margin-block-end: ${({ theme, mb }) => createSpacing(theme, mb)};
  margin-block-start: ${({ theme, mt }) => createSpacing(theme, mt)};
  margin-inline-start: ${({ theme, ml }) => createSpacing(theme, ml)};
  margin-inline-end: ${({ theme, mr }) => createSpacing(theme, mr)};
  padding-inline-start: ${({ theme, pl }) => createSpacing(theme, pl)};
  padding-inline-end: ${({ theme, pr }) => createSpacing(theme, pr)};
  padding-block-start: ${({ theme, pt }) => createSpacing(theme, pt)};
  padding-block-end: ${({ theme, pb }) => createSpacing(theme, pb)};
  ${({ fullWidth }) => (fullWidth ? _fullWidth : null)}
  display: inline-block;
`
